var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("手动录入"),
      visible: _vm.dialogVisible,
      width: 700
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 12
      },
      rules: _vm.dataRule
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("临时分保")))]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分保费累计（万元）"),
      prop: "premium"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      change: _vm.premiumChange
    },
    model: {
      value: _vm.dataFrom.premium,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium", $$v);
      },
      expression: "dataFrom.premium"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应付保费累计（万元）"),
      prop: "premium2"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      change: _vm.premiumChange2
    },
    model: {
      value: _vm.dataFrom.premium2,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium2", $$v);
      },
      expression: "dataFrom.premium2"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分保佣金累计（万元）"),
      prop: "premium3"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      change: _vm.premiumChange3
    },
    model: {
      value: _vm.dataFrom.premium3,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium3", $$v);
      },
      expression: "dataFrom.premium3"
    }
  })], 1), _c("div", {
    staticClass: "title"
  }, [_vm._v("合同分保")]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分保费累计（万元）"),
      prop: "premium4"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      change: _vm.premiumChange
    },
    model: {
      value: _vm.dataFrom.premium4,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium4", $$v);
      },
      expression: "dataFrom.premium4"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应付保费累计（万元）"),
      prop: "premium5"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      change: _vm.premiumChange2
    },
    model: {
      value: _vm.dataFrom.premium5,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium5", $$v);
      },
      expression: "dataFrom.premium5"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分保佣金累计（万元）"),
      prop: "premium6"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      change: _vm.premiumChange3
    },
    model: {
      value: _vm.dataFrom.premium6,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium6", $$v);
      },
      expression: "dataFrom.premium6"
    }
  })], 1), _c("div", {
    staticClass: "title"
  }, [_vm._v("合计")]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分保费累计（万元）")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.dataFrom.premium8,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium8", $$v);
      },
      expression: "dataFrom.premium8"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应付保费累计（万元）")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.dataFrom.premium9,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium9", $$v);
      },
      expression: "dataFrom.premium9"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分保佣金累计（万元）")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.dataFrom.premium10,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "premium10", $$v);
      },
      expression: "dataFrom.premium10"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };